window.initSliders = function(root = document) {
  root.querySelectorAll('.slider-container.hover-only').forEach(container => {
    if (container.dataset.hoverInit) return;
    container.dataset.hoverInit = "true";
    const wrapper = container.querySelector('.slider-wrapper');
    if (!wrapper) return;
    const images = wrapper.querySelectorAll('.product-card__image');
    if (images.length < 2) return;
    container.addEventListener('mouseenter', () => {
      wrapper.style.transition = 'none';
      wrapper.style.transform = `translateX(-100%)`;
    });
    container.addEventListener('mouseleave', () => {
      wrapper.style.transition = 'none';
      wrapper.style.transform = `translateX(0%)`;
    });
  });

  root.querySelectorAll('.slider-container.has-slider').forEach(container => {
    if (container.dataset.sliderInit) return;
    container.dataset.sliderInit = "true";
    const wrapper = container.querySelector('.slider-wrapper');
    if (!wrapper) return;
    const images = wrapper.querySelectorAll('.product-card__image');
    if (images.length <= 1) return;
    const leftArrow = container.querySelector('.slider-arrow-left');
    const rightArrow = container.querySelector('.slider-arrow-right');
    const segments = container.querySelectorAll('.segment');
    let currentIndex = 0;
    const total = images.length;
    function goTo(index) {
      currentIndex = (index + total) % total;
      wrapper.style.transform = `translateX(-${currentIndex * 100}%)`;
      segments.forEach((seg, idx) => seg.classList.toggle('active', idx === currentIndex));
    }
    leftArrow?.addEventListener('click', e => { e.preventDefault(); e.stopPropagation(); goTo(currentIndex - 1); });
    rightArrow?.addEventListener('click', e => { e.preventDefault(); e.stopPropagation(); goTo(currentIndex + 1); });
    segments.forEach(seg => { seg.addEventListener('click', e => { e.preventDefault(); e.stopPropagation(); goTo(parseInt(seg.dataset.index)); }); });
    goTo(0);
  });
};

document.addEventListener('DOMContentLoaded', () => {
  initSliders();
});

document.addEventListener('shopify:section:load', e => {
  if (e.target.tagName.toLowerCase() === 'product-recommendations') {
    initSliders(e.target);
  }
});

document.addEventListener('shopify:section:reorder', e => {
  if (e.target.tagName.toLowerCase() === 'product-recommendations') {
    initSliders(e.target);
  }
});
